import { render, staticRenderFns } from "./MultiPointPacketEditor.vue?vue&type=template&id=19366014&scoped=true&"
import script from "./MultiPointPacketEditor.vue?vue&type=script&lang=ts&"
export * from "./MultiPointPacketEditor.vue?vue&type=script&lang=ts&"
import style0 from "./MultiPointPacketEditor.vue?vue&type=style&index=0&id=19366014&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19366014",
  null
  
)

export default component.exports